import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function LegalNavbar() {
  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="cursor-pointer">
          <Logo variant="dark" />
        </Link>
        <Link
          to="/"
          className="flex items-center gap-1.5 text-sm font-medium text-[#1B3A5C] hover:text-[#3D9E8C] transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line text-base" />
          Volver al inicio
        </Link>
      </div>
    </header>
  );
}
